import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'

export type AccountantModuleType = 'none' | 'luca' | 'zirve' | 'eta'
export interface SessionState {
   signedIn: boolean
   token: string | null
   refresh_token: string | null
   isAccountant?: boolean | null
   activeAccountantModule?: AccountantModuleType
   fromAccountantToken?: string | null
}

const initialState: SessionState = {
   signedIn: false,
   token: null,
   refresh_token: null,
}

const sessionSlice = createSlice({
   name: `${SLICE_BASE_NAME}/session`,
   initialState,
   reducers: {
      signInSuccess(
         state,
         action: PayloadAction<{
            access_token: string
            refresh_token: string
            isAccountant: boolean
         }>,
      ) {
         state.signedIn = true
         state.token = action.payload.access_token
         state.refresh_token = action.payload.refresh_token
         state.isAccountant = action.payload.isAccountant
      },
      authorizeAccountFromAccountantModule(
         state,
         action: PayloadAction<{
            access_token: string
            refresh_token: string
         }>,
      ) {
         state.fromAccountantToken = state.token
         state.signedIn = true
         state.token = action.payload.access_token
         state.refresh_token = action.payload.refresh_token
         state.isAccountant = false
      },
      authorizeAccountantFromAccountModule(state) {
         state.signedIn = true
         state.token = state.fromAccountantToken!
         state.fromAccountantToken = null
         state.isAccountant = true
      },
      signOutSuccess(state) {
         state.signedIn = false
         state.token = null
         state.isAccountant = null
         state.activeAccountantModule = 'none'
         state.fromAccountantToken = null
      },
      changeActiveModule(state, action: PayloadAction<{ module: AccountantModuleType }>) {
         state.activeAccountantModule = action.payload.module
      },
   },
})

export const { signInSuccess, signOutSuccess, changeActiveModule, authorizeAccountFromAccountantModule, authorizeAccountantFromAccountModule } =
   sessionSlice.actions
export default sessionSlice.reducer
